<template>
    <transition>
        <v-flex :class="attributes.width">
            <BnHelpField :name="attributes.mezo" :active="!!attributes.help" :prefix="!!attributes.forgalmiBetukod">
                <v-select
                        :style="getStyle()"
                        color="secondaryButtonColor"
                        slot="two"
                        @focus="focus()"
                        :label="attributes.label"
                        :items="varosLista"
                        item-text="varos"
                        item-value="varoskod"
                        :disabled="!isEditable()"
                        v-model="inputVal"
                        :mask="attributes.mask"
                        :hint="getPersistentHint"
                        @keyup="onKeyUp()"
                        persistent-hint
                        persistent-placeholder
                        clearable
                        :counter="attributes.counter"
                        :path="attributes.path"
                        :suffix="attributes.suffix"
                        @blur="blurFn()"
                        :prefix="attributes.prefix"
                        :ref="attributes.mezo"
                        :id="attributes.mezo + '-input'"
                        :attributes="attributes"
                        :afterDatePath="attributes.afterDatePath"
                        :beforeDatePath="attributes.beforeDatePath"
                        :append-icon="attributes.innerIcon"
                        @click:clear="clearFn"
                        @keydown="keyDownFn($event)"
                        @keypress="keyDownFn($event)"
                        :outlined="cfg.props.outlined"
                        placeholder="  "
                />
            </BnHelpField>
        </v-flex>
    </transition>
</template>

<script>
import storeValueByPath from '../../mixins/StoreValueByPath';
import bnFormField from '../../mixins/bnFormField';
import cimService from '../../services/CimService';
import { isIrszam } from '../../modules/Validators';

export default {
    name: 'BnVaros',
    mixins: [storeValueByPath, bnFormField],
    data() {
        return {
            varosLista: [],
        };
    },
    props: ['zip'],
    watch: {
        zip() {
            this.updateList();
        },
    },
    mounted() {
        this.updateList();
    },
    methods: {
        updateList() {
            if (isIrszam(this.zip)) {
                cimService.getVarosLista(this.zip).then((response) => {
                    this.varosLista = response.data;

                    if (this.varosLista.length === 0) {
                        this.varosLista.push({
                            varoskod: -9999,
                            varos: 'Érvénytelen irányítószám!',
                        });
                    }

                    if (this.varosLista.length === 1) {
                        this.inputVal = this.varosLista[0].varoskod;
                    }
                });
            }
        },
    },
};
</script>

<style scoped>

</style>
